import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

const ArrowIndicator = () => {
  const [opacityArrowDowIndicator, setOpacityArrowDowIndicator] = useState(0);

  const handleScrollFiredArrowIndicator = {
    subscribe: ({ scrollStart = 0, scrollEnd = 0 }) => {
      const scrollY = window.scrollY;
      const scrollRange = scrollEnd - scrollStart;
      if (scrollY >= scrollStart && scrollY <= scrollEnd && scrollRange > 0) {
        setOpacityArrowDowIndicator(1);
      } else {
        setOpacityArrowDowIndicator(0);
      }
    },
    unsubscribe: () => setOpacityArrowDowIndicator(0)
  };

  useEffect(() => {
    const evaluateScroll = () =>
      handleScrollFiredArrowIndicator.subscribe({
        scrollStart: 0,
        scrollEnd: window.innerHeight / 2
      });
    evaluateScroll();
    document.addEventListener('scroll', evaluateScroll);
    return () => {
      document.removeEventListener('scroll', evaluateScroll);
      handleScrollFiredArrowIndicator.unsubscribe();
    };
  }, []);

  return (
    <>
      {opacityArrowDowIndicator > 0 && (
        <div
          id="arrow-down-indicator"
          className="p-5"
          style={{
            opacity: opacityArrowDowIndicator
          }}>
          <FontAwesomeIcon icon={faChevronDown} className="icon" />
        </div>
      )}
    </>
  );
};

export default ArrowIndicator;
